import React, { useState } from "react";
import { IconContext } from "react-icons";
import {
	AiOutlineCheckCircle,
	AiOutlineClockCircle,
} from "react-icons/ai";
import { FiAlertTriangle } from "react-icons/fi";
import { MdOutlineSync } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Loader from "../../components/Loader/Loader";
import { useListManager } from "../../contexts/list.manager";
import AccessGroupService from "../../services/AccessGroupService";
import AccessPointService from "../../services/AccessModuleService";
import CondoUserService from "../../services/CondoUserService";
import MqttService from "../../services/MqttService";
import UnitService from "../../services/UnitService";
import Button from "../Button/Button";
import ModalComponent from "../Modal/ModalComponent";
import "./SyncIcon.css";
import { GoIssueDraft } from "react-icons/go";
import ReadersService from "../../services/ReadersService";
import InterlockService from "../../services/InterlockService";
import AntiPassbackService from "../../services/AntiPassbackService";

const SyncIcon = (props) => {
	const { t } = useTranslation();

	const [modalAdressConflictIsOpen, setModalAdressConflictIsOpen] =
		useState(false);
	const [modalImportIsOpen, setModalImportIsOpen] = useState(false);
	const [modalDeleteIsOpen, setModalDeleteIsOpen] = useState(false);
	const [modalSyncIsOpen, setModalSyncIsOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const { closeForm } = useListManager();
	const navigate = useNavigate();

	const handleConfirmImportModal = async () => {
		if (props.listEntityName === "accessPoints") {
			await MqttService.sendImportRequest({
				action: "getAccessPoint",
				origin: "frontEnd",
				content: { accessPoint: props.data },
			});
		}

		if (props.listEntityName === "groups") {
			await MqttService.sendImportRequest({
				action: "getGroup",
				origin: "frontEnd",
				content: { group: props.data },
			});
		}

		if (props.listEntityName === "units") {
			await MqttService.sendImportRequest({
				action: "getUnit",
				origin: "frontEnd",
				content: { unit: props.data },
			});
		}

		if (props.listEntityName === "condoUsers") {
			await MqttService.sendImportRequest({
				action: "getCondoUser",
				origin: "frontEnd",
				content: { condoUser: props.data },
			});
		}

		if (props.listEntityName === "readers") {
			await MqttService.sendImportRequest({
				action: "getReader",
				origin: "frontEnd",
				content: { reader: props.data },
			});
		}

		if (props.listEntityName === "interlocks") {
			await MqttService.sendImportRequest({
				action: "getInterlock",
				origin: "frontEnd",
				content: { interlock: props.data },
			});
		}

		if (props.listEntityName === "antiPassbacks") {
			await MqttService.sendImportRequest({
				action: "getAntiPassback",
				origin: "frontEnd",
				content: { antiPassback: props.data },
			});
		}

		setModalImportIsOpen(false);
	};

	const handleConfirmDeleteModal = async () => {
		if (props.listEntityName === "accessPoints") {
			await AccessPointService.deleteAccessPoint(props.data.id);
			navigate("../consulta-access-points");
		}

		if (props.listEntityName === "groups") {
			await AccessGroupService.deleteAccessGroup(props.data.id);
			navigate("../consulta-groups");
		}

		if (props.listEntityName === "units") {
			await UnitService.deleteUnit(props.data.id);
			navigate("../consulta-units");
		}

		if (props.listEntityName === "condoUsers") {
			await CondoUserService.deleteCondoUser(props.data.id);
			navigate("../consulta-condo-users");
		}

		if (props.listEntityName === "readers") {
			await ReadersService.deleteReader(props.data.id);
			navigate("../consulta-readers");
		}

		if (props.listEntityName === "interlocks") {
			await InterlockService.deleteInterlock(props.data.id);
			navigate("../consulta-interlocks");
		}

		if (props.listEntityName === "antiPassbacks") {
			await AntiPassbackService.deleteAntiPassback(props.data.id);
			navigate("../consulta-anti-passbacks");
		}

		closeForm();
		setModalDeleteIsOpen(false);
	};

	const handleConfirmSyncModal = async () => {
		setIsLoading(true);

		if (props.listEntityName === "accessPoints") {
			await MqttService.sendResyncOne({
				content: { id_access_point: props.data.id },
				action: "resyncOneAccess",
				origin: "frontEnd",
			});
		}

		if (props.listEntityName === "units") {
			await MqttService.sendResyncOne({
				content: { externalId: props.data.externalId },
				action: "resyncOneUnit",
				origin: "frontEnd",
			});
		}

		if (props.listEntityName === "groups") {
			await MqttService.sendResyncOne({
				content: {
					id_access_group: props.data.id,
					licenseId: props.data.licenseId,
				},
				action: "resyncOneGroup",
				origin: "frontEnd",
			});
		}

		if (props.listEntityName === "readers") {
			await MqttService.sendResyncOne({
				content: {
					id_reader: props.data.id,
					licenseId: props.data.licenseId,
				},
				action: "resyncOneReader",
				origin: "frontEnd",
			});
		}

		if (props.listEntityName === "condoUsers") {
			await MqttService.sendResyncOne({
				content: {
					id_condo_user: props.data.id,
					licenseId: props.data.licenseId,
				},
				action: "resyncOneCondoUser",
				origin: "frontEnd",
			});
		}

		if (props.listEntityName === "interlocks") {
			await MqttService.sendResyncOne({
				content: {
					id_interlock: props.data.id,
					licenseId: props.data.licenseId,
				},
				action: "resyncOneInterlock",
				origin: "frontEnd",
			});
		}

		if (props.listEntityName === "antiPassbacks") {
			await MqttService.sendResyncOne({
				content: {
					id_anti_passback: props.data.id,
					licenseId: props.data.licenseId,
				},
				action: "resyncOneAntiPassback",
				origin: "frontEnd",
			});
		}

		const timeout = setTimeout(() => {
			setIsLoading(false);
			clearTimeout(timeout);
		}, 5000);

		setModalSyncIsOpen(false);
	};

	const handleOpenModal = (type) => {
		if (type === "sync") setModalSyncIsOpen(true);
		if (type === "import") setModalImportIsOpen(true);
		if (type === "delete") setModalDeleteIsOpen(true);
		if (type === "address") setModalAdressConflictIsOpen(true);
	};

	const handleCloseModal = (type) => {
		if (type === "sync") setModalSyncIsOpen(false);
		if (type === "import") setModalImportIsOpen(false);
		if (type === "delete") setModalDeleteIsOpen(false);
		if (type === "address") setModalAdressConflictIsOpen(false);
	};

	function renderIcon(_syncStatus, isLoading) {
		let iconComponent;
		let syncStatus = _syncStatus;

		if (Array.isArray(syncStatus)) {
			syncStatus = syncStatus.reduce(
				(acc, s) => (acc.startsWith("0x") ? acc : s.status),
				"notSynced"
			);
		}

		switch (syncStatus) {
			case "draft":
				if (props.isCard)
					return (
						<div
							style={{
								width: "150px",
								color: "var(--textColor)",
								opacity: "0.5",
							}}
						>
							{t("sync.draft")}
						</div>
					);

				iconComponent = (
					<IconContext.Provider
						value={{ className: "synced-icon opacity-50!" }}
					>
						<GoIssueDraft
							title={t("sync.draft")}
							color="var(--textColor)"
							size={18}
						/>
					</IconContext.Provider>
				);
				break;

			case "deleting":
				if (props.isCard)
					return (
						<div
							style={{
								width: "150px",
								color: "var(--textColor)",
								opacity: "0.5",
							}}
						>
							{t("sync.toDelete")}
						</div>
					);

				iconComponent = (
					<IconContext.Provider
						value={{ className: "synced-icon opacity-50!" }}
					>
						<GoIssueDraft
							title={t("sync.toDelete")}
							color="#eb4c4c"
							size={18}
						/>
					</IconContext.Provider>
				);
				break;

			case "synced":
				if (props.isCard)
					return (
						<div style={{ width: "150px", color: "green" }}>
							{t("sync.synced")}
						</div>
					);

				iconComponent = (
					<IconContext.Provider value={{ className: "synced-icon" }}>
						<AiOutlineCheckCircle
							title={t("sync.syncedWithEquipment")}
							color="rgb(1, 219, 1)"
							size={18}
						/>
					</IconContext.Provider>
				);
				break;

			case "started":
				if (props.isCard)
					return (
						<div style={{ width: "150px", color: "green" }}>
							{t("sync.processing")}
						</div>
					);

				iconComponent = (
					<IconContext.Provider value={{ className: "synced-icon" }}>
						<AiOutlineClockCircle
							title={t("sync.syncingWithEquipment")}
							color="rgb(219, 179, 1)"
							size={18}
						/>
					</IconContext.Provider>
				);
				break;

			case "notSynced":
				if (props.isCard) {
					iconComponent = (
						<Button
							className="button-white card-buttons"
							label={t("sync.sync")}
							onClick={() => handleOpenModal("sync")}
						/>
					);
				}

				if (isLoading && !props.isCard) {
					iconComponent = (
						<div style={{ marginTop: "-100px", marginLeft: "20px" }}>
							<Loader height="18" width="18" strokeWidth="5" />
						</div>
					);
				}

				if (!isLoading && !props.isCard) {
					iconComponent = (
						<IconContext.Provider
							value={{ className: "not-synced-icon" }}
						>
							<MdOutlineSync
								title={t("sync.syncDataWithEquipment")}
								onClick={() => handleOpenModal("sync")}
								size={20}
							/>
						</IconContext.Provider>
					);
				}
				break;

			case "error":
				if (props.isCard) {
					iconComponent = (
						<Button
							className="button-white card-buttons"
							label={t("sync.viewConflict")}
							onClick={() => handleOpenModal("sync")}
						/>
					);
				} else {
					iconComponent = (
						<IconContext.Provider
							value={{ className: "not-imported-icon" }}
						>
							<MdOutlineSync
								title={t("sync.syncDataWithEquipment")}
								onClick={() => handleOpenModal("sync")}
								size={20}
							/>
						</IconContext.Provider>
					);
				}
				break;

			case "0x0008":
				if (props.isCard) {
					iconComponent = (
						<Button
							className="button-white card-buttons"
							label={t("sync.viewConflict")}
							onClick={() => handleOpenModal("delete")}
						/>
					);
				} else {
					iconComponent = (
						<IconContext.Provider
							value={{ className: "not-imported-icon" }}
						>
							<FiAlertTriangle
								title={t("sync.deleteNonexistentEquipmentData")}
								onClick={() => handleOpenModal("delete")}
								size={18}
							/>
						</IconContext.Provider>
					);
				}
				break;

			case "0x0007":
				if (props.isCard) {
					iconComponent = (
						<Button
							className="button-white card-buttons"
							label={t("sync.viewConflict")}
							onClick={() => handleOpenModal("import")}
						/>
					);
				} else {
					iconComponent = (
						<IconContext.Provider
							value={{ className: "not-imported-icon" }}
						>
							<FiAlertTriangle
								title={t("sync.addExistingEquipmentData")}
								onClick={() => handleOpenModal("import")}
								size={18}
							/>
						</IconContext.Provider>
					);
				}
				break;

			case "0x000F":
				if (props.isCard) {
					iconComponent = (
						<Button
							className="button-white card-buttons"
							label={t("sync.viewConflict")}
							onClick={() => handleOpenModal("address")}
						/>
					);
				} else {
					iconComponent = (
						<IconContext.Provider
							value={{ className: "not-imported-icon" }}
						>
							<FiAlertTriangle
								title={t("sync.addressAlreadyRegistered")}
								onClick={() => handleOpenModal("address")}
								size={18}
							/>
						</IconContext.Provider>
					);
				}
				break;

			default:
				if (props.isCard) {
					iconComponent = (
						<Button
							className="button-white card-buttons"
							label={t("sync.sync")}
							onClick={() => handleOpenModal("sync")}
						/>
					);
				}

				if (isLoading && !props.isCard) {
					iconComponent = (
						<div style={{ marginTop: "-100px", marginLeft: "20px" }}>
							<Loader height="18" width="18" strokeWidth="5" />
						</div>
					);
				}

				if (!isLoading && !props.isCard) {
					iconComponent = (
						<IconContext.Provider
							value={{ className: "not-synced-icon" }}
						>
							<MdOutlineSync
								title={t("sync.syncDataWithEquipment")}
								onClick={() => handleOpenModal("sync")}
								size={20}
							/>
						</IconContext.Provider>
					);
				}
				break;
		}

		return iconComponent;
	}

	function formatStatus(status) {
		if (Array.isArray(status)) {
			status = status.reduce(
				(acc, s) =>
					acc.startsWith("0x") || s.status === "error" ? acc : s.status,
				"notSynced"
			);
		}

		if (status === "synced") return t("sync.synced");
		if (status === "started") return t("sync.syncing");
		if (status === "draft")
			return (
				<span className="opacity-50 italic">
					{t("sync.notSaved")}
				</span>
			);

		if (status?.startsWith?.("0x") || status === "error")
			return t("sync.error");

		if (status === "deleting")
			return (
				<span className="opacity-50 italic">
					{t("sync.toDelete")}
				</span>
			);

		return t("sync.sync");
	}

	function defineStatusColor(status) {
		if (Array.isArray(status)) {
			status = status.reduce(
				(acc, s) =>
					acc.startsWith("0x") || s.status === "error" ? acc : s.status,
				"notSynced"
			);
		}

		if (status === "synced") return "#22cf22";
		if (status === "started") return "#e6bd41";
		if (status === "draft") return "var(--textColor)";
		if (status?.startsWith?.("0x") || status === "error")
			return "#eb4c4c";
		if (status === "deleting") return "#eb4c4c";

		return "#1174f7";
	}

	return (
		<React.Fragment>
			<span
				className={`list-line-span ${props.showLabel
						? "inline-flex! items-center gap-1.5! **:m-0! h-[18px]!"
						: ""
					} ${props.lastOperation === "delete"
						? "**:text-red-500!"
						: ""
					}`}
			>
				{renderIcon(props.syncStatus, isLoading)}

				{props.showLabel && (
					<span
						style={{
							color: defineStatusColor(props.syncStatus),
						}}
					>
						{formatStatus(props.syncStatus)}
					</span>
				)}
			</span>

			<ModalComponent
				modalIsOpen={modalImportIsOpen}
				modalText={t("sync.dataAlreadyPresentOnEquipment")}
				handleConfirm={handleConfirmImportModal}
				handleCancel={() => handleCloseModal("import")}
			>
				<p>{t("sync.wantToImportToCloud")}</p>
			</ModalComponent>

			<ModalComponent
				modalIsOpen={modalAdressConflictIsOpen}
				modalText={t("sync.addressAlreadyInUseOnEquipment")}
				hideButtons={true}
			>
				<p style={{ marginBottom: "30px" }}>
					{t("sync.avoidChangesOutsideCloud")}
				</p>

				<p style={{ marginBottom: "30px" }}>
					{t("sync.deleteRecordAndChooseAnotherRs485Address")}
				</p>

				<Button
					onClick={() => handleCloseModal("address")}
					label={t("sync.close")}
				/>
			</ModalComponent>

			<ModalComponent
				modalIsOpen={modalDeleteIsOpen}
				modalText={t("sync.dataDoesNotExistOnEquipment")}
				handleConfirm={handleConfirmDeleteModal}
				handleCancel={() => handleCloseModal("delete")}
			>
				<p>{t("sync.wantToDeleteFromCloud")}</p>
			</ModalComponent>

			<ModalComponent
				modalIsOpen={modalSyncIsOpen}
				modalText={t("sync.wantToSyncDataWithEquipment")}
				handleConfirm={handleConfirmSyncModal}
				handleCancel={() => handleCloseModal("sync")}
			/>
		</React.Fragment>
	);
};

export default SyncIcon;